import React  from 'react'
import FlowsListWrapper from 'shared/components/common/FlowsListWrapper/FlowsListWrapper.component'
import AnalyticsSectionItem from 'analytics/components/AnalyticsSectionItem/AnalyticsSectionItem.component'
import styles from './AnalyticsSectionsSideBar.module.scss'

const sectionItems = [
  { title: 'Interactions', route: 'interactions' },
  { title: 'Handover', route: 'handover' },
  { title: 'Events', route: 'events' },
  { title: 'Sessions', route: 'sessions' },
  { title: 'Channel volume', route: 'inbound' },
  { title: 'Outbound volume', route: 'outbound' },
  // { title: 'Tags', route: 'tags' },
    
  { title: 'Audience', route: 'users' },
  // { title: 'Sentiments', route: 'sentiments' },
  { title: 'Export', route: 'report' }
]

const renderSectionItems = () => sectionItems.map((item, i) => (
  <AnalyticsSectionItem
    key={i}
    title={item.title}
    route={item.route}
  />
))

const AnalyticsSectionsSideBar = () => (
  <main className={styles.main}>
    <header className={styles.headerTitle}>
        Analytics
    </header>

    <br />

    <FlowsListWrapper>
      { renderSectionItems() }
    </FlowsListWrapper>
  </main>
)

AnalyticsSectionsSideBar.propTypes = {}

export default AnalyticsSectionsSideBar
